import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

// Import Css
import './socialMediaComponents.css';


export function SocialMediaComponents() {

  return (

    <div className="box-social-media-components">

        <a className="icon-social-media icon-fb" href="#" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebookF}/>
        </a>

        <a className="icon-social-media icon-tk" href="#" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTiktok}/>
        </a>

        <a className="icon-social-media icon-Ins" href="#" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram}/>
        </a>

        <a className="icon-social-media icon-Wts" href="https://wa.me/593992818717" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faWhatsapp}/>        
        </a>
        
    </div>

  );

}
